import PropTypes from 'prop-types'
import styles from './ChannelLayout.module.scss'

import Footer from '../../Footer'

const ChannelLayout = props => {
  return (
    <div className={styles.component}>
      <div className={styles.content}>{props.children}</div>
      <Footer />
    </div>
  )
}

ChannelLayout.propTypes = {
  children: PropTypes.node
}

export default ChannelLayout
